import { ItemsListProps } from '~shared/ItemsList'
import { ItemsList } from '~shared'
import { Grid, GlowHeading } from '~ui'

interface SearchResultsProps extends ItemsListProps {
  title?: string
}

const SearchResults = ({
  title,
  items,
  placeholderItemsCount,
  showLoadMoreButton,
  onLoadMore,
  loading,
  noDataText,
}: SearchResultsProps) => (
  <Grid gap={24} marginBottom={items.length < 3 ? 150 : 0}>
    {title && (
      <GlowHeading Tag="h2" size="h2">
        {title}
      </GlowHeading>
    )}
    <ItemsList
      noDataText={noDataText}
      showLoadMoreButton={showLoadMoreButton}
      placeholderItemsCount={placeholderItemsCount}
      onLoadMore={onLoadMore}
      loading={loading}
      items={items}
    />
  </Grid>
)

export default SearchResults
